import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { EDIT } from "const"
import { hasProjectAccess } from "client/utils"
import {
    PRM_STUDY_SESSION,
    StoreType,
    addModal,
} from "client/store"
import {
    PageForm,
    FormGroup,
    Label,
    Input,
    Textarea,
    DateFormatter,
    DivInput,
    Button,
} from "client/components"

const Form = () => {
    const baseRoute = useSelector((state: StoreType) => state.studySession.baseRoute)
    const session = useSelector((state: StoreType) => state.studySession.sessionView)

    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const { sessionFields } = projectSettings.study.sessionFieldsAssigned ? projectSettings.study : accountSettings.study

    const editUrl = `${baseRoute}/${EDIT}/${session.id}`
    const editAccess = hasProjectAccess(PRM_STUDY_SESSION, EDIT)

    return (
        <PageForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.study}</Label>
                        <Input type="text" value={session.study ? session.study.name : ""} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.date}</Label>
                        <DivInput widePadding><DateFormatter date={session.date} showTime={false} /></DivInput>
                    </FormGroup>
                </Col>
                <Col xs={6}>
                    <FormGroup>
                        <Label>{lang.startTime}</Label>
                        <Input type="text" value={session.startTime} readOnly />
                    </FormGroup>
                </Col>
                <Col xs={6}>
                    <FormGroup>
                        <Label>{lang.endTime}</Label>
                        <Input type="text" value={session.endTime} readOnly />
                    </FormGroup>
                </Col>
                <Col xs={12}>
                    {
                        sessionFields.facilitator && (
                            <FormGroup>
                                <Label>{lang.facilitator}</Label>
                                <Input type="text" value={session.facilitator ? session.facilitator.name : ""} readOnly />
                            </FormGroup>
                        )
                    }
                    {
                        sessionFields.scribe && (
                            <FormGroup>
                                <Label>{lang.scribe}</Label>
                                <Input type="text" value={session.scribe ? session.scribe.name : ""} readOnly />
                            </FormGroup>
                        )
                    }
                    {
                        sessionFields.comment && (
                            <FormGroup>
                                <Label>{lang.comment}</Label>
                                <Textarea value={session.comment} readOnly />
                            </FormGroup>
                        )
                    }
                </Col>
                {
                    editAccess && (
                        <Col xs={12}>
                            <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                {lang.edit}
                            </Button>
                        </Col>
                    )
                }
            </Row>
        </PageForm>
    )
}
export default Form
